import React from 'react';
import '../template-file-css/document-file-template.css'; 


export const ACS_InitialIntakeNote = ({
    itemsRef,
    showErrorFor, 
}) => {

    return (
        <form id='ACS_InitialIntakeNote' className='file-pdf-document'>
            <div className='file-template'>  
    <table>
        <tr>
            <td className='w-750'>
                <span className='eleHeader'>Location</span>
                <input type="checkbox" id="cbLocation_1" name="cbLocation" className='add-only' value="Home" />
                Home<br />
                <input type="checkbox" id="cbLocation_2" name="cbLocation" className='add-only' value="Office" />
                Office<br />
                <input type="checkbox" id="cbLocation_3" name="cbLocation" className='add-only' value="Other" />
                Other:
                    <input type='text' id="txtLocation" name="txtLocation" className='add-only' />
            </td>
        </tr>
    </table>
    <table>
        <tr>
            <td className='w-750'>PLEASE PLACE AN (X) BY SERVICE(S) BEING ORDERED FOR CONSUMER <strong>PHYSICIAN ORDER OF SERVICES </strong>
            </td>
        </tr>
        <tr>
            <td className='w-375'>
                <span className='eleHeader'>Service Name</span>
            </td>
            <td className='w-375'>
                <span className='eleHeader'>Duration</span>
            </td>
        </tr>
        <tr>
            <td className='w-375'>
                <input type="checkbox" id="cbServiceName_DiagnosticAssessment" name="cbServiceName" className='add-only' value="Diagnostic Assessment" />
                Diagnostic Assessment
            </td>
            <td className='w-375'>
                <input type='text' id="txtDuration_1" name="txtDuration_1" className='add-only'/>
            </td>
        </tr>
        <tr>
            <td className='w-375'>
                <input type="checkbox" id="cbServiceName_PsychiatricTreatment" name="cbServiceName" className='add-only' value="Psychiatric Treatment" />
                Psychiatric Treatment
            </td>
            <td className='w-375'>
                <input type='text' id="txtDuration_2" name="txtDuration_2" className='add-only'/>
            </td>
        </tr>
        <tr>
            <td className='w-375'>
                <input type="checkbox" id="cbServiceName_NursingAssessmentCare" name="cbServiceName" className='add-only' value="Nursing Assessment & Care" />
                Nursing Assessment & Care
            </td>
            <td className='w-375'>
                <input type='text' id="txtDuration_3" name="txtDuration_3" className='add-only'/>
            </td>
        </tr>
        <tr>
            <td className='w-375'>
                <input type="checkbox" id="cbServiceName_MedicationAdministration" name="cbServiceName" className='add-only' value="Medication Administration" />
                Medication Administration
            </td>
            <td className='w-375'>
                <input type='text' id="txtDuration_4" name="txtDuration_4" className='add-only'/>
            </td>
        </tr>
        <tr>
            <td className='w-375'>
                <input type="checkbox" id="cbServiceName_TherapeuticInterventionsFromACE" name="cbServiceName" className='add-only' value="Therapeutic interventions from ACE" />
                Therapeutic interventions from ACE
            </td>
            <td className='w-375'>
                <input type='text' id="txtDuration_5" name="txtDuration_5" className='add-only'/>
            </td>
        </tr>
    </table>
    <p>
        <span className='eleHeader'>Identifying Information/HPI Summary</span>
        <textarea id="txtIdentifyingInformation" name="txtIdentifyingInformation" className='add-only' rows={5}></textarea>
    </p>
    <h4>Vitals</h4>
    <table>
        <tr>
            <td className='w-125'>
                <span className='eleHeader'>B/P</span>
                <input type='text' id="txtBP" name="txtBP" className='add-only' />
            </td>
            <td className='w-125'>
                <span className='eleHeader'>HR</span>
                <input type='text' id="txtHR" name="txtHR" className='add-only' />
            </td>
            <td className='w-125'>
                <span className='eleHeader'>Temp</span>
                <input type='text' id="txtTemp" name="txtTemp" className='add-only' />
            </td>
            <td className='w-125'>
                <span className='eleHeader'>Resp</span>
                <input type='text' id="txtResp" name="txtResp" className='add-only' />
            </td>
            <td className='w-125'>
                <span className='eleHeader'>Height</span>
                <input type='text' id="txtHeight" name="txtHeight" className='add-only' />
            </td>
            <td className='w-125'>
                <span className='eleHeader'>Weight</span>
                <input type='text' id="txtWeight" name="txtWeight" className='add-only' />
            </td>
        </tr>
    </table>
    <h4>Current Symptoms</h4>
    <table>
        <tr>
            <td className='w-750'>
                <span className='eleHeader'>Behavioral Symptoms</span>
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbBehavioralSymptoms_Defiance" name="cbBehavioralSymptoms" value="Defiance" className='add-only' />
                Defiance</td>
            <td className='w-250'>
                <input type="checkbox" id="cbBehavioralSymptoms_Opposition" name="cbBehavioralSymptoms" value="Opposition" className='add-only' />
                Opposition</td>
            <td className='w-250'>
                <input type="checkbox" id="cbBehavioralSymptoms_Drugs" name="cbBehavioralSymptoms" value="Drugs" className='add-only' />
                Drugs</td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbBehavioralSymptoms_Alcohol" name="cbBehavioralSymptoms" value="Alcohol" className='add-only' />
                Alcohol</td>
            <td className='w-250'>
                <input type="checkbox" id="cbBehavioralSymptoms_Runaway" name="cbBehavioralSymptoms" value="Runaway" className='add-only' />
                Runaway</td>
            <td className='w-250'>
                <input type="checkbox" id="cbBehavioralSymptoms_PhysicalFights" name="cbBehavioralSymptoms" value="Physical fights w/parents" className='add-only' />
                Physical fights w/parents</td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbBehavioralSymptoms_Promiscuity" name="cbBehavioralSymptoms" value="Promiscuity" className='add-only' />
                Promiscuity</td>
            <td className='w-250'>
                <input type="checkbox" id="cbBehavioralSymptoms_Lies" name="cbBehavioralSymptoms" value="Lies" className='add-only' />
                Lies</td>
            <td className='w-250'>
                <input type="checkbox" id="cbBehavioralSymptoms_Stealing" name="cbBehavioralSymptoms" value="Stealing" className='add-only' />
                Stealing</td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbBehavioralSymptoms_PoorGrades" name="cbBehavioralSymptoms" value="PoorGrades" className='add-only' />
                Poor Grades</td>
            <td className='w-250'>
                <input type="checkbox" id="cbBehavioralSymptoms_SchoolDisruptions" name="cbBehavioralSymptoms" value="School Disruptions" className='add-only' />
                School Disruptions</td>
            <td className='w-250'>
                <input type="checkbox" id="cbBehavioralSymptoms_Tantrums" name="cbBehavioralSymptoms" value="Tantrums" className='add-only' />
                Tantrums</td>
        </tr>
        <tr>
            <td className='w-750'>
                <input type="checkbox" id="cbBehavioralSymptoms_Other" name="cbBehavioralSymptoms" className='add-only' value="Other" />
                Other:
                    <input type='text' id="txtBehavioralSymptoms_Other" name="txtBehavioralSymptoms_Other" className='add-only' />
            </td>
        </tr>
        <tr>
            <td className='w-750'>
                <span className='eleHeader'>Depressive Symptoms</span>
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbDeprSymptom_DepressedMood" name="cbDeprSymptom" className='add-only' value="Depressed Mood" />
                Depressed Mood
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbDeprSymptom_SleepProblems" name="cbDeprSymptom" className='add-only' value="Sleep Problems" />
                Sleep Problems
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbDeprSymptom_EatingProblems" name="cbDeprSymptom" className='add-only' value="Eating Problems" />
                Eating Problems
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbDeprSymptom_PoorEnergy" name="cbDeprSymptom" className='add-only' value="Poor Energy" />
                Poor Energy
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbDeprSymptom_PoorConcentration" name="cbDeprSymptom" className='add-only' value="Poor Concentration" />
                Poor Concentration
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbDeprSymptom_Irritability" name="cbDeprSymptom" className='add-only' value="Irritability" />
                Irritability
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbDeprSymptom_Guilt" name="cbDeprSymptom" className='add-only' value="Guilt" />
                Guilt
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbDeprSymptom_Hopeless" name="cbDeprSymptom" className='add-only' value="Hopeless" />
                Hopeless
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbDeprSymptom_Explosiveness" name="cbDeprSymptom" className='add-only' value="Explosiveness" />
                Explosiveness
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbDeprSymptom_Anhedonia" name="cbDeprSymptom" className='add-only' value="Anhedonia" />
                Anhedonia
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbDeprSymptom_SocialIsolation" name="cbDeprSymptom" className='add-only' value="Social Isolation" />
                Social Isolation
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbDeprSymptom_SI" name="cbDeprSymptom" className='add-only' value="SI" />
                SI
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbDeprSymptom_WithIntent" name="cbDeprSymptom" className='add-only' value="with intent" />
                with intent
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbDeprSymptom_Cutting" name="cbDeprSymptom" className='add-only' value="Cutting" />
                Cutting
            </td>
            <td className='w-250'>&nbsp;</td>
        </tr>
        <tr>
            <td className='w-750'>
                <input type="checkbox" id="cbDeprSymptom_Other" name="cbDeprSymptom" className='add-only' value="Other" />
                Other:
                    <input type='text' id="txtDeprSymptom_Other" name="txtDeprSymptom_Other" className='add-only' />
            </td>
        </tr>
        <tr>
            <td className='w-750'>
                <span className='eleHeader'>Anxiety Symptoms</span>
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbAnxietySymptom_PanicAttacks" name="cbAnxietySymptoms" className='add-only' value="Panic Attacks" />
                Panic Attacks
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbAnxietySymptom_Stressed" name="cbAnxietySymptoms" className='add-only' value="Stressed" />
                Stressed
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbAnxietySymptom_FrequentWorries" name="cbAnxietySymptoms" className='add-only' value="Frequent Worries" />
                Frequent Worries
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbAnxietySymptom_SomaticComplaints" name="cbAnxietySymptoms" className='add-only' value="Somatic Complaints" />
                Somatic Complaints
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbAnxietySymptom_Obsessions" name="cbAnxietySymptoms" className='add-only' value="Obsessions" />
                Obsessions
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbAnxietySymptom_Compulsions" name="cbAnxietySymptoms" className='add-only' value="Compulsions" />
                Compulsions
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbAnxietySymptom_EasilyOverwhelmed" name="cbAnxietySymptoms" className='add-only' value="Easily Overwhelmed" />
                Easily Overwhelmed
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbAnxietySymptom_EatingDisorder" name="cbAnxietySymptoms" className='add-only' value="Eating Disorder" />
                Eating Disorder
            </td>
            <td className='w-250'>&nbsp;</td>
        </tr>
        <tr>
            <td className='w-750'>
                <input type="checkbox" id="cbAnxietySymptom_Other" name="cbAnxietySymptom" className='add-only' value="Other" />
                Other:
                    <input type='text' id="txtAnxietySymptom_Other" name="txtAnxietySymptom_Other" className='add-only' />
            </td>
        </tr>
        <tr>
            <td className='w-750'>
                <span className='eleHeader'>Manic Symptoms</span>
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbManicSymptom_RacingThoughts" name="cbManicSymptom" className='add-only' value="Racing thoughts" />
                Racing thoughts
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbManicSymptom_DecreasedNeedForSleep" name="cbManicSymptom" className='add-only' value="Decreased need for sleep" />
                Decreased need for sleep
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbManicSymptom_IncreasedGoalDirectedActivity" name="cbManicSymptom" className='add-only' value="Increased goal directed activity" />
                Increased goal directed activity
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbManicSymptom_MoodSwings" name="cbManicSymptom" className='add-only' value="Mood Swings" />
                Mood Swings
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbManicSymptom_Euphoria" name="cbManicSymptom" className='add-only' value="Euphoria" />
                Euphoria
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbManicSymptom_PressuredSpeech" name="cbManicSymptom" className='add-only' value="Pressured Speech" />
                Pressured Speech
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbManicSymptom_Hypersexual" name="cbManicSymptom" className='add-only' value="Hypersexual" />
                Hypersexual
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbManicSymptom_Grandiosity" name="cbManicSymptom" className='add-only' value="Grandiosity" />
                Grandiosity
            </td>
            <td className='w-250'>&nbsp;</td>
        </tr>
        <tr>
            <td className='w-750'>
                <input type="checkbox" id="cbManicSymptom_Other" name="cbManicSymptom" className='add-only' value="Other" />
                Other:
                    <input type='text' id="txtManicSymptom_Other" name="txtManicSymptom_Other" className='add-only' />
            </td>
        </tr>
        <tr>
            <td className='w-750'>
                <span className='eleHeader'>ADHD Symptoms</span>
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbAdhdSymptoms_LosingThings" name="cbAdhdSymptoms" value="Losing things" className='add-only' />
                Losing Things
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbAdhdSymptoms_ForgettingThings" name="cbAdhdSymptoms" value="Forgetting things" className='add-only' />
                Forgetting Things
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbAdhdSymptoms_ImpulsivityProblems" name="cbAdhdSymptoms" value="Impulsivity Problems" className='add-only' />
                Impulsivity Problems
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbAdhdSymptoms_FinishingTasks" name="cbAdhdSymptoms" value="FinishingTasks" className='add-only' />
                Finishing Tasks
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbAdhdSymptoms_BlurtingOut" name="cbAdhdSymptoms" value="Blurting out" className='add-only' />
                Blurting out
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbAdhdSymptoms_Interrupting" name="cbAdhdSymptoms" value="Interrupting" className='add-only' />
                Interrupting
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbAdhdSymptoms_Impatience" name="cbAdhdSymptoms" value="Impatience" className='add-only' />
                Impatience
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbAdhdSymptoms_Inattentiveness" name="cbAdhdSymptoms" value="Inattentiveness" className='add-only' />
                Inattentiveness
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbAdhdSymptoms_Distractibility" name="cbAdhdSymptoms" value="Distractibility" className='add-only' />
                Distractibility
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbAdhdSymptoms_Hyperactivity" name="cbAdhdSymptoms" value="Hyperactivity" className='add-only' />
                Hyperactivity
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbAdhdSymptoms_Fidgetiness" name="cbAdhdSymptoms" value="Fidgetiness" className='add-only' />
                Fidgetiness
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbAdhdSymptoms_Problems sitting still" name="cbAdhdSymptoms" value="Problems sitting still" className='add-only' />
                Problems sitting still
            </td>
        </tr>
        <tr>
            <td className='w-750'>
                <input type="checkbox" id="cbAdhdSymptoms_Other" name="cbAdhdSymptoms" className='add-only' value="Other" />
                Other:
                    <input type='text' id="txtAdhdSymptoms_Other" name="txtAdhdSymptoms_Other" className='add-only' />
            </td>
        </tr>
        <tr>
            <td className='w-750'>
                <span className='eleHeader'>PTSD Symptoms</span>
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbPtsdSymptoms_Nightmares" name="cbPtsdSymptoms" className='add-only' value="Nightmares" />
                Nightmares
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbPtsdSymptoms_Flashbacks" name="cbPtsdSymptoms" className='add-only' value="Flashbacks" />
                Flashbacks
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbPtsdSymptoms_Dissociation" name="cbPtsdSymptoms" className='add-only' value="Dissociation" />
                Dissociation
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbPtsdSymptoms_Startle" name="cbPtsdSymptoms" className='add-only' value="Startle" />
                Startle
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbPtsdSymptoms_Avoidance" name="cbPtsdSymptoms" className='add-only' value="Avoidance" />
                Avoidance
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbPtsdSymptoms_IntrusiveThoughts" name="cbPtsdSymptoms" className='add-only' value="Intrusive	thoughts" />
                Intrusive thoughts
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbPtsdSymptoms_ReplaysTrauma" name="cbPtsdSymptoms" className='add-only' value="Replays Trauma" />
                Replays Trauma (Acting Out)
            </td>
            <td className='w-500'>
                <input type="checkbox" id="cbPtsdSymptoms_Other" name="cbPtsdSymptoms" className='add-only' value="Other" />
                Other:
                    <input type='text' id="txtPtsdSymptoms_Other" name="txtPtsdSymptoms_Other" className='add-only' />
            </td>
        </tr>
        <tr>
            <td className='w-750'>
                <span className='eleHeader'>Psychosis</span>
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbPsychosis_Ah" name="cbPsychosis" className='add-only' value="AH" />
                AH
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbPsychosis_Vh" name="cbPsychosis" className='add-only' value="VH" />
                VH
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbPsychosis_Delusions" name="cbPsychosis" className='add-only' value="Delusions" />
                Delusions
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbPsychosis_Paranoia" name="cbPsychosis" className='add-only' value="Paranoia" />
                Paranoia
            </td> 
        </tr>
        <tr> 
            <td className='w-500'>
                <input type="checkbox" id="cbPsychosis_Other" name="cbPsychosis" className='add-only' value="Other" />
                Other:
                    <input type='text' id="txtPsychosis_Other" name="txtPsychosis_Other" className='add-only' />
            </td>
        </tr>
        <tr>
            <td className='w-750'>
                <span className='eleHeader'>Violence</span>
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbViolence_Fighting" name="cbViolence" className='add-only' value="Fighting" />
                Fighting
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbViolence_HI" name="cbViolence" className='add-only' value="HI" />
                HI
            </td>
            <td className='w-250'>&nbsp;</td>
        </tr>
        <tr>
            <td className='w-750'>
                <input type="checkbox" id="cbViolence_Other" name="cbViolence" className='add-only' value="Other" />
                Other:
                    <input type='text' id="txtViolence_Other" name="txtViolence_Other" className='add-only' />
            </td>
        </tr>
    </table>
    <table>
        <tr>
            <td className='w-375'>
                <span className='eleHeader'>Current Meds</span>
                <input type='text' id="txtCurrentMeds" name="txtCurrentMeds" className='add-only' />
            </td>
            <td className='w-375'>
                <span className='eleHeader'>Previous Psychiatric Meds</span>
                <input type='text' id="txtPreviousPsychiatricMeds" name="txtPreviousPsychiatricMeds" className='add-only' />
            </td>
        </tr>
    </table>
    <table>
        <tr>
            <td className='w-375'>
                <span className='eleHeader'>Previous Psychiatric History</span>
                <input type="checkbox" id="cbPrevPsychHist_1" name="cbPrevPsychHist" className='add-only' value="Hospitalized" />
                Hospitalized<br />
                <input type="checkbox" id="cbPrevPsychHist_2" name="cbPrevPsychHist" className='add-only' value="Outpatient" />
                Outpatient<br />
                <input type="checkbox" id="cbPrevPsychHist_3" name="cbPrevPsychHist" className='add-only' value="No previous outpatient treatment history" />
                No previous outpatient treatment history
            </td>
            <td className='w-187'>
                <span className='eleHeader'>Total Times</span>
                <input type='text' id="txtTotalTimes" name="txtTotalTimes" className='add-only' />
            </td>
            <td className='w-188'>
                <span className='eleHeader'>Last Hospitalization</span>
                <input type='date' id="txtLastHospitalization" name="txtLastHospitalization" className='add-only' />
            </td>
        </tr>
    </table>
    <p>
        <span className='eleHeader'>Locations and Dates</span>
        <textarea id="txtLocationsAndDates" name="txtLocationsAndDates" className='add-only' rows={5}></textarea>
    </p>
    <table>
        <tr>
            <td className='w-375'>
                <span className='eleHeader'>PMHx</span>
                <input type='text' id="txtPMHx" name="txtPMHx" className='add-only' />
            </td>
        </tr>
    </table>
    <p>
        <span className='eleHeader'>Allergic To</span>
        <input type="checkbox" id="cbKNDA" name="cbKNDA" className='add-only' value="KNDA" />
        KNDA<br />
        <textarea id="txtAllergies" name="txtAllergies" className='add-only' rows={5}></textarea>
    </p>
    <table>
        <tr>
            <td className='w-750'>
                <span className='eleHeader'>Family Psychiatric History</span>
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbFamilyPsychHistory_1" name="cbFamilyPsychHistory" value="ADD/ADHD" className='add-only' />
                ADD/ADHD</td>
            <td className='w-250'>
                <input type="checkbox" id="cbFamilyPsychHistory_2" name="cbFamilyPsychHistory" value="Bipolar" className='add-only' />
                Bipolar</td>
            <td className='w-250'>
                <input type="checkbox" id="cbFamilyPsychHistory_3" name="cbFamilyPsychHistory" value="Depression" className='add-only' />
                Depression</td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbFamilyPsychHistory_4" name="cbFamilyPsychHistory" value="Anxiety" className='add-only' />
                Anxiety</td>
            <td className='w-250'>
                <input type="checkbox" id="cbFamilyPsychHistory_5" name="cbFamilyPsychHistory" value="Substance Abuse" className='add-only' />
                Substance Abuse</td>
            <td className='w-250'>
                <input type="checkbox" id="cbFamilyPsychHistory_6" name="cbFamilyPsychHistory" value="Schizophrenia/Schizoaffective" className='add-only' />
                Schizophrenia/Schizoaffective</td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbFamilyPsychHistory_7" name="cbFamilyPsychHistory" value="Panic Disorder" className='add-only' />
                Panic Disorder</td>
            <td className='w-250'>
                <input type="checkbox" id="cbFamilyPsychHistory_8" name="cbFamilyPsychHistory" value="OCD" className='add-only' />
                OCD</td>
            <td className='w-250'>
                <input type="checkbox" id="cbFamilyPsychHistory_9" name="cbFamilyPsychHistory" value="Mood Disorder" className='add-only' />
                Mood Disorder</td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbFamilyPsychHistory_10" name="cbFamilyPsychHistory" value="Eating Disorder" className='add-only' />
                Eating Disorder</td>
            <td className='w-250'>
                <input type="checkbox" id="cbFamilyPsychHistory_11" name="cbFamilyPsychHistory" value="Learning Disorder" className='add-only' />
                Learning Disorder</td>
            <td className='w-250'>
                <input type="checkbox" id="cbFamilyPsychHistory_12" name="cbFamilyPsychHistory" value="Personality Disorder" className='add-only' />
                Personality Disorder</td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbFamilyPsychHistory_13" name="cbFamilyPsychHistory" value="Suicide" className='add-only' />
                Suicide</td>
            <td className='w-250'>
                <input type="checkbox" id="cbFamilyPsychHistory_14" name="cbFamilyPsychHistory" value="Homicide" className='add-only' />
                Homicide</td>
            <td className='w-250'>&nbsp;</td>
        </tr>
        <tr>
            <td className='w-750'>
                <input type="checkbox" id="cbFamilyPsychHistory_15" name="cbFamilyPsychHistory" value="Family Medical History" />
                Family Medical History:<br />
                <textarea id="txtFamMedHist" name="txtFamMedHist" className='add-only' rows={5}></textarea>
            </td>
        </tr>
    </table>
    <h4>Social History</h4>
    <table>
        <tr>
            <td className='w-750'>
                <span className='eleHeader'>Relationship Status</span>
            </td>
        </tr>
        <tr>
            <td className='w-375'>
                <strong>CHILD:</strong><br />
                <select id="ddlRelationshipStatus_Child" name="ddlRelationshipStatus_Child" className='add-only'>
                    <option value="NA"></option>
                    <option value="Parent married">Parent married</option>
                    <option value="Parents divorced">Parents divorced</option>
                    <option value="Single parent">Single parent</option>
                    <option value="Other parent involved">Other parent involved</option>
                </select><br />
                <input type="checkbox" id="cbRelationshipStatus_Child" name="cbRelationshipStatus_Child" className='add-only' value="Other" />
                Other:
                    <input type='text' id="txtRelationshipStatus_ChildOther" name="txtRelationshipStatus_ChildOther" className='add-only' />
            </td>
            <td className='w-375'>
                <strong>ADULT:</strong><br />
                <select id="ddlRelationshipStatus_Adult" name="ddlRelationshipStatus_Adult" className='add-only'>
                    <option value="NA"></option>
                    <option value="Single">Single</option>
                    <option value="Married">Married</option>
                    <option value="Separated">Separated</option>
                    <option value="Divorced">Divorced</option>
                    <option value="Widow/Widower">Widow/Widower</option>
                </select><br />
                <input type="checkbox" id="cbRelationshipStatus_Adult" name="cbRelationshipStatus_Adult" className='add-only' value="Other" />
                Other:
                    <input type='text' id="txtRelationshipStatus_AdultOther" name="txtRelationshipStatus_AdultOther" className='add-only' />
            </td>
        </tr>
    </table>
    <table>
        <tr>
            <td className='w-750'>
                <span className='eleHeader'>Pt lives with</span>
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbPtliveswith_Mother" name="cbPtliveswith" value="Mother" className='add-only' />
                Mother	
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbPtliveswith_Father" name="cbPtliveswith" value="Father" className='add-only' />
                Father
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbPtliveswith_Stepfather" name="cbPtliveswith" value="Stepfather" className='add-only' />
                Stepfather
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbPtliveswith_Stepmother" name="cbPtliveswith" value="Stepmother" className='add-only' />
                Stepmother
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbPtliveswith_Sister" name="cbPtliveswith" value="Sister" className='add-only' />
                Sister(s)
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbPtliveswith_Brother" name="cbPtliveswith" value="Brother" className='add-only' />
                Brother(s)
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbPtliveswith_Stepsister" name="cbPtliveswith" value="Stepsister" className='add-only' />
                Stepsister(s)
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbPtliveswith_Stepbrother" name="cbPtliveswith" value="Stepbrother" className='add-only' />
                Stepbrother(s)
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbPtliveswith_Grandmother" name="cbPtliveswith" value="Grandmother" className='add-only' />
                Grandmother
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbPtliveswith_Grandfather" name="cbPtliveswith" value="Grandfather" className='add-only' />
                Grandfather</td>
            <td className='w-250'>
                <input type="checkbox" id="cbPtliveswith_FosterMother" name="cbPtliveswith" value="Foster Mother" className='add-only' />
                Foster Mother</td>
            <td className='w-250'>
                <input type="checkbox" id="cbPtliveswith_FosterFather" name="cbPtliveswith" value="Foster Father" className='add-only' />
                Foster Father</td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbPtliveswith_FosterSiblings" name="cbPtliveswith" value="Foster Siblings" className='add-only' />
                Foster Siblings</td> 
        </tr>
        <tr> 
            <td className='w-500'>
                <input type="checkbox" id="cbPtliveswith_Other" name="cbPtliveswith_Other" className='add-only' value="Other" />
                Other:
                    <input type='text' id="txtPtliveswith_Other" name="txtPtliveswith_Other" className='add-only' />
            </td>
        </tr>
    </table>
    <p>
        <span className='eleHeader'>Physical abuse</span>
        <select id="ddlPhysicalAbuse" name="ddlPhysicalAbuse" className='add-only w-150 custom-add-only'>
            <option value="NA"></option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
        </select>
        &nbsp;&nbsp;
        Reported
        &nbsp;&nbsp;
        <input type='text' id="txtReported_Physical" name="txtReported_Physical" className='add-only w-150 custom-add-only' />
    </p>
    <p>
        <span className='eleHeader'>Sexual abuse</span>
        <select id="ddlSexualAbuse" name="ddlSexualAbuse" className='add-only w-150 custom-add-only'>
            <option value="NA"></option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
        </select>
        &nbsp;&nbsp;Reported
        &nbsp;&nbsp;
        <input type='text' id="txtReported_Sexual" name="txtReported_Sexual" className='add-only w-150 custom-add-only' />
    </p>
    <p>
        <span className='eleHeader'>Neglect</span>
        <select id="ddlNeglect" name="ddlNeglect" className='add-only w-150 custom-add-only'>
            <option value="NA"></option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
        </select>
        &nbsp;&nbsp;Reported
        &nbsp;&nbsp;
        <input type='text' id="txtReported_Neglect" name="txtReported_Neglect" className='add-only w-150 custom-add-only' />
    </p>
    <table>
        <tr>
            <td className='w-750'>
                <span className='eleHeader'>Developmental Hx</span>
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbSubAbuseHx_Unremarkable" name="cbDevelopmentalHx" className='add-only' value="Marijuana" />
                Unremarkable</td>
            <td className='w-250'>
                <input type="checkbox" id="cbDevelopmentalHx_InterUteroExposures" name="cbDevelopmentalHx" className='add-only' value="Inter-utero exposures" />
                Inter-utero exposures</td>
            <td className='w-250'>
                <input type="checkbox" id="cbDevelopmentalHx_PreTerm" name="cbDevelopmentalHx" className='add-only' value="pre-term" />
                Pre-term</td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbDevelopmentalHx_DelayedSpeech" name="cbDevelopmentalHx" className='add-only' value="Delayed Speech" />
                Delayed Speech</td>
            <td className='w-250'>
                <input type="checkbox" id="cbDevelopmentalHx_DelayedMotor" name="cbDevelopmentalHx" className='add-only' value="Delayed Motor" />
                Delayed Motor</td>
            <td className='w-250'>
                <input type="checkbox" id="cbDevelopmentalHx_Unknown" name="cbDevelopmentalHx" className='add-only' value="unknown" />
                Unknown</td>
        </tr>
        <tr>
            <td className='w-750'>
                <span className='eleHeader'>Pregnancy Hx</span>
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbPregHx_1" name="cbPregHx" className='add-only' value="Complications during pregnancy" />
                Complications during pregnancy</td>
            <td className='w-250'>
                <input type="checkbox" id="cbPregHx_2" name="cbPregHx" className='add-only' value="On meds during pregnancy" />
                On meds during pregnancy</td>
            <td className='w-250'>
                <input type="checkbox" id="cbPregHx_3" name="cbPregHx" className='add-only' value="Post-Partum Depression" />
                Post-Partum Depression</td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbPregHx_4" name="cbPregHx" className='add-only' value="Substance Abuse during pregnancy" />
                Substance Abuse during pregnancy</td> 
        </tr>
        <tr> 
            <td className='w-500'>
                <input type="checkbox" id="cbPregHx_5" name="cbPregHx" className='add-only' value="Other" />
                Other:
                    <input type='text' id="txtPregHx_Other" name="txtPregHx_Other" className='add-only' />
            </td>
        </tr>
        <tr>
            <td className='w-750'>
                <span className='eleHeader'>School Hx</span>
            </td>
        </tr>
        <tr>
            <td className='w-750'>Grade Level:</td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbGradeLevel_RepeatGrade" name="cbGradeLevel" className='add-only' value="Repeat grade" />
                Repeat grade</td>
            <td className='w-250'>
                <input type="checkbox" id="cbGradeLevel_SpecialClasses" name="cbGradeLevel" className='add-only' value="Special classes/IEP" />
                Special classes/IEP</td>
            <td className='w-250'>
                <input type="checkbox" id="cbGradeLevel_Suspensions" name="cbGradeLevel" className='add-only' value="Suspensions" />
                Suspensions</td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbGradeLevel_Expulsion" name="cbGradeLevel" className='add-only' value="Expulsion" />
                Expulsion</td>
            <td className='w-250'>
                <input type="checkbox" id="cbGradeLevel_K12" name="cbGradeLevel" className='add-only' value="K-12" />
                K-12</td>
            <td className='w-250'>
                <input type="checkbox" id="cbGradeLevel_AlternativeSchool" name="cbGradeLevel" className='add-only' value="Alternative School" />
                Alternative School</td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbGradeLevel_DropOut" name="cbGradeLevel" className='add-only' value="Drop Out" />
                Drop Out</td>
            <td className='w-250'>
                <input type="checkbox" id="cbGradeLevel_GED" name="cbGradeLevel" className='add-only' value="GED" />
                GED</td>
            <td className='w-250'>
                <input type="checkbox" id="cbGradeLevel_College" name="cbGradeLevel" className='add-only' value="College" />
                College</td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbGradeLevel_GradSchool" name="cbGradeLevel" className='add-only' value="Grad School" />
                Grad School</td>
            <td className='w-250'>&nbsp;</td>
            <td className='w-250'>&nbsp;</td>
        </tr>
        <tr>
            <td className='w-750'>
                <span className='eleHeader'>Substance Abuse Hx</span>
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbSubAbuseHx_CurrentUse" name="cbSubAbuseHx" className='add-only' value="Current Usea" />
                Current Use
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbSubAbuseHx_HistoryOfUse" name="cbSubAbuseHx" className='add-only' value="History of Use" />
                History of Use
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbSubAbuseHx_None" name="cbSubAbuseHx" className='add-only' value="None" />
                None
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbSubAbuseHx_Marijuana" name="cbSubAbuseHx" className='add-only' value="Marijuana" />
                Marijuana
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbSubAbuseHx_Etoh" name="cbSubAbuseHx" className='add-only' value="ETOH" />
                ETOH
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbSubAbuseHx_CrystalMethamp" name="cbSubAbuseHx" className='add-only' value="Crystal Methamphetamine" />
                Crystal Methamphetamine
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbSubAbuseHx_Mdma" name="cbSubAbuseHx" className='add-only' value="MDMA" />
                MDMA
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbSubAbuseHx_Stimulants" name="cbSubAbuseHx" className='add-only' value="Stimulants" />
                Stimulants
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbSubAbuseHx_Pcp" name="cbSubAbuseHx" className='add-only' value="PCP" />
                PCP
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbSubAbuseHx_Ketamine" name="cbSubAbuseHx" className='add-only' value="Ketamine" />
                Ketamine
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbSubAbuseHx_Heroin" name="cbSubAbuseHx" className='add-only' value="Heroin" />
                Heroin
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbSubAbuseHx_Cocaine" name="cbSubAbuseHx" className='add-only' value="Cocaine" />
                Cocaine
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbSubAbuseHx_LSD" name="cbSubAbuseHx" className='add-only' value="LSD" />
                LSD
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbSubAbuseHx_Inhalants" name="cbSubAbuseHx" className='add-only' value="Inhalants" />
                Inhalants
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbSubAbuseHx_Hashish" name="cbSubAbuseHx" className='add-only' value="Hashish" />
                Hashish
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbSubAbuseHx_Mushrooms" name="cbSubAbuseHx" className='add-only' value="Mushrooms" />
                Mushrooms
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbSubAbuseHx_Benzodiazepines" name="cbSubAbuseHx" className='add-only' value="Benzodiazepines" />
                Benzodiazepines
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbSubAbuseHx_Oxycontin" name="cbSubAbuseHx" className='add-only' value="Oxycontin" />
                Oxycontin
            </td>
        </tr>
        <tr>
            <td className='w-750'>
                <input type="checkbox" id="cbSubAbuseHx_Other" name="cbSubAbuseHx" className='add-only' value="Other" />
                Other:
                    <input type='text' id="txtSubAbuse_Other" name="txtSubAbuse_Other" className='add-only' />
            </td>
        </tr>
        <tr>
            <td className='w-750'>
                <span className='eleHeader'>Legal Hx</span>
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbLegalHx_ViolationOfProbation" name="cbLegalHx" className='add-only' value="Violation of probation" />
                Violation of probation
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbLegalHx_UnrulyChild" name="cbLegalHx" className='add-only' value="Unruly child" />
                Unruly child
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbLegalHx_Runaway" name="cbLegalHx" className='add-only' value="Runaway" />
                Runaway
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbLegalHx_DrugPossession" name="cbLegalHx" className='add-only' value="Drug possession" />
                Drug possession
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbLegalHx_SellingDrugs" name="cbLegalHx" className='add-only' value="Selling drugs" />
                Selling drugs
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbLegalHx_Battery" name="cbLegalHx" className='add-only' value="Battery" />
                Battery
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbLegalHx_Assault" name="cbLegalHx" className='add-only' value="Assault" />
                Assault
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbLegalHx_Burglary" name="cbLegalHx" className='add-only' value="Burglary/theft" />
                Burglary/theft
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbLegalHx_Probation" name="cbLegalHx" className='add-only' value="Probation" />
                Probation
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbLegalHx_SchoolDisruption" name="cbLegalHx" className='add-only' value="School disruption" />
                School disruption
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbLegalHx_Trespass" name="cbLegalHx" className='add-only' value="Trespass" />
                Trespass
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbLegalHx_Truancy" name="cbLegalHx" className='add-only' value="Truancy" />
                Truancy
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbLegalHx_None" name="cbLegalHx" className='add-only' value="None" />
                None
            </td> 
        </tr>
        <tr> 
            <td className='w-500'>
                <input type="checkbox" id="cbLegalHx_Other" name="cbLegalHx" className='add-only' value="Other" />
                Other:
                    <input type='text' id="txtLegalHx_Other" name="txtSubAbuse_Other" className='add-only' />
            </td>
        </tr>
    </table>
    <h4>Mental Status Examination</h4>
    <p>
        <span className="small">(Check all items that apply)</span>
    </p>
    <table>
        <tr>
            <td className='w-750'>
                <span className='eleHeader'>Oriented To</span>
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbOriented_Time" name="cbOriented" className='add-only' value="Time" />
                Time
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbOriented_Place" name="cbOriented" className='add-only' value="Place" />
                Place
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbOriented_Person" name="cbOriented" className='add-only' value="Person" />
                Person
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbOriented_Thing" name="cbOriented" className='add-only' value="Thing" />
                Thing
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbOriented_Situation" name="cbOriented" className='add-only' value="Situation" />
                Situation
            </td> 
        </tr>
        <tr> 
            <td className='w-250'>
                <input type="checkbox" id="cbOriented_Other" name="cbOriented" className='add-only' value="Other" />
                Other:
                    <input type='text' id="txtOriented_Other" name="txtOriented_Other" className='add-only' />
            </td>
        </tr>
        <tr>
            <td className='w-750'>
                <span className='eleHeader'>Appearance</span>
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbAppearance_Neat" name="cbAppearance" className='add-only' value="Neat" />
                Neat
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbAppearance_Fastidious" name="cbAppearance" className='add-only' value="Fastidious" />
                Fastidious
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbAppearance_Casual" name="cbAppearance" className='add-only' value="Casual" />
                Casual
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbAppearance_Flamboyant" name="cbAppearance" className='add-only' value="Flamboyant" />
                Flamboyant
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbAppearance_Bizarre" name="cbAppearance" className='add-only' value="Bizarre" />
                Bizarre
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbAppearance_Disheveled" name="cbAppearance" className='add-only' value="Disheveled" />
                Disheveled
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbAppearance_LowSelfCare" name="cbAppearance" className='add-only' value="low self care" />
                low self care
            </td> 
        </tr>
        <tr> 
            <td className='w-500'>
                <input type="checkbox" id="cbAppearance_Other" name="cbAppearance" className='add-only' value="Other" />
                Other:
                    <input type='text' id="txtAppearance_Other" name="txtAppearance_Other" className='add-only' />
            </td>
        </tr>
        <tr>
            <td className='w-750'>
                <span className='eleHeader'>Demeanor</span>
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbDemeanor_Demanding" name="cbDemeanor" className='add-only' value="Demanding" />
                Demanding
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbDemeanor_Friendly" name="cbDemeanor" className='add-only' value="Friendly" />
                Friendly
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbDemeanor_Hostile" name="cbDemeanor" className='add-only' value="Hostile" />
                Hostile
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbDemeanor_Manipulative" name="cbDemeanor" className='add-only' value="Manipulative" />
                Manipulative
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbDemeanor_Negative" name="cbDemeanor" className='add-only' value="Negative" />
                Negative
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbDemeanor_Aloof" name="cbDemeanor" className='add-only' value="Aloof" />
                Aloof
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbDemeanor_Guarded" name="cbDemeanor" className='add-only' value="Guarded" />
                Guarded
            </td> 
        </tr>
        <tr> 
            <td className='w-500'>
                <input type="checkbox" id="cbDemeanor_Other" name="cbDemeanor" className='add-only' value="Other" />
                Other:
                    <input type='text' id="txtDemeanor_Other" name="txtDemeanor_Other" className='add-only' />
            </td>
        </tr>
        <tr>
            <td className='w-750'>
                <span className='eleHeader'>Movement</span>
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbMovement_Normal" name="cbMovement" className='add-only' value="Normal" />
                Normal
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbMovement_Agitated" name="cbMovement" className='add-only' value="Hyper/Agitated" />
                Hyper/Agitated
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbMovement_Slowed" name="cbMovement" className='add-only' value="Slowed" />
                Slowed
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbMovement_Tics" name="cbMovement" className='add-only' value="Tics" />
                Tics
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbMovement_tremors" name="cbMovement" className='add-only' value="tremors" />
                tremors
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbMovement_Fidgety" name="cbMovement" className='add-only' value="fidgety" />
                fidgety
            </td>
        </tr>
        <tr>
            <td className='w-750'>
                <input type="checkbox" id="cbMovement_Other" name="cbMovement" className='add-only' value="Other" />
                Other:
                    <input type='text' id="txtMovement_Other" name="txtMovement_Other" className='add-only' />
            </td>
        </tr>
        <tr>
            <td className='w-750'>
                <span className='eleHeader'>Mood</span>
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbMood_euthymic" name="cbMood" className='add-only' value="euthymic" />
                Euthymic
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbMood_dysthymic" name="cbMood" className='add-only' value="dysthymic" />
                Dysthymic
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbMood_agitated" name="cbMood" className='add-only' value="agitated" />
                Agitated
            </td>
        </tr>
        <tr>
            <td className='w-750'>
                <input type="checkbox" id="cbMood_Other" name="cbMood" className='add-only' value="Other" />
                Other:
                    <input type='text' id="txtMood_Other" name="txtMood_Other" className='add-only' />
            </td>
        </tr>
        <tr>
            <td className='w-750'>
                <span className='eleHeader'>Affect</span>
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbAffect_FullRange" name="cbAffect" className='add-only' value="Full range" />
                Full range
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbAffect_Constricted" name="cbAffect" className='add-only' value="Constricted" />
                Constricted
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbAffect_Labile" name="cbAffect" className='add-only' value="Labile" />
                Labile
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbAffect_Irritable" name="cbAffect" className='add-only' value="Irritable" />
                Irritable
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbAffect_Blunted" name="cbAffect" className='add-only' value="Blunted" />
                Blunted
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbAffect_Flat" name="cbAffect" className='add-only' value="Flat" />
                Flat
            </td>
        </tr>
        <tr>
            <td className='w-750'>
                <input type="checkbox" id="cbAffect_Other" name="cbAffect" className='add-only' value="Other" />
                Other:
                    <input type='text' id="txtAffect_Other" name="txtAffect_Other" className='add-only' />
            </td>
        </tr>
        <tr>
            <td className='w-750'>
                <span className='eleHeader'>Speech</span>
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbSpeech_WNL" name="cbSpeech" className='add-only' value="WNL" />
                WNL
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbSpeech_Hyperverbal" name="cbSpeech" className='add-only' value="Hyper verbal" />
                Hyper verbal
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbSpeech_Pressure" name="cbSpeech" className='add-only' value="Pressure speech" />
                Pressure speech
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbSpeech_Slow" name="cbSpeech" className='add-only' value="Slow" />
                Slow
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbSpeech_Soft" name="cbSpeech" className='add-only' value="Soft" />
                Soft
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbSpeech_Loud" name="cbSpeech" className='add-only' value="Loud" />
                Loud
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbSpeech_Sparse" name="cbSpeech" className='add-only' value="Sparse" />
                Sparse
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbSpeech_Dysfluent" name="cbSpeech" className='add-only' value="Dysfluent" />
                Dysfluent
            </td> 
        </tr>
        <tr> 
            <td className='w-250'>
                <input type="checkbox" id="cbSpeech_Other" name="cbSpeech" className='add-only' value="Other" />
                Other:
                    <input type='text' id="txtSpeech_Other" name="txtSpeech_Other" className='add-only' />
            </td>
        </tr>
        <tr>
            <td className='w-750'>
                <span className='eleHeader'>Thought Processes</span>
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbThoughtProc_GoalDirected" name="cbThoughtProc" className='add-only' value="Goal directed" />
                Goal directed
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbThoughtProc_FlightOfIdeas" name="cbThoughtProc" className='add-only' value="Flight of Ideas" />
                Flight of Ideas
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbThoughtProc_Tangential" name="cbThoughtProc" className='add-only' value="Tangential" />
                Tangential
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbThoughtProc_Circumstantial" name="cbThoughtProc" className='add-only' value="Circumstantial" />
                Circumstantial
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbThoughtProc_RacingThoughts" name="cbThoughtProc" className='add-only' value="Racing thoughts" />
                Racing thoughts
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbThoughtProc_Blocking" name="cbThoughtProc" className='add-only' value="Blocking" />
                Blocking
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbThoughtProc_Perseveration" name="cbThoughtProc" className='add-only' value="Perseveration" />
                Perseveration
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbThoughtProc_LooseAssociations" name="cbThoughtProc" className='add-only' value="Loose Associations" />
                Loose Associations
            </td> 
        </tr>
        <tr> 
            <td className='w-250'>
                <input type="checkbox" id="cbThoughtProc_Other" name="cbThoughtProc" className='add-only' value="Other" />
                Other:
                    <input type='text' id="txtThoughtProc_Other" name="txtThoughtProc_Other" className='add-only' />
            </td>
        </tr>
        <tr>
            <td className='w-750'>
                <span className='eleHeader'>Estimated Intelligence</span>
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbEstIntelligence_BelowAverage" name="cbEstIntelligence" className='add-only' value="Below Average" />
                Below Average
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbEstIntelligence_Average" name="cbEstIntelligence" className='add-only' value="Average/Above Average" />
                Average/Above Average
            </td> 
        </tr>
        <tr> 
            <td className='w-250'>
                <input type="checkbox" id="cbEstIntelligence_Other" name="cbEstIntelligence" className='add-only' value="Other" />
                Other:
                    <input type='text' id="txtEstIntelligence_Other" name="txtEstIntelligence_Other" className='add-only' />
            </td>
        </tr>
        <tr>
            <td className='w-750'>
                <span className='eleHeader'>Thought Content</span>
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbThoContent_Normal" name="cbThoContent" className='add-only' value="Normal" />
                Normal
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbThoContent_Delusions" name="cbThoContent" className='add-only' value="Delusions" />
                Delusions
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbThoContent_Obsessions" name="cbThoContent" className='add-only' value="Obsessions" />
                Obsessions
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbThoContent_Compulsions" name="cbThoContent" className='add-only' value="Compulsions" />
                Compulsions
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbThoContent_IdeasOfReference" name="cbThoContent" className='add-only' value="Ideas of reference" />
                Ideas of reference
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbThoContent_Phobia" name="cbThoContent" className='add-only' value="Phobia" />
                Phobia
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbThoContent_Preoccupation" name="cbThoContent" className='add-only' value="Preoccupation" />
                Preoccupation
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbThoContent_Paranoia" name="cbThoContent" className='add-only' value="Paranoia" />
                Paranoia
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbThoContent_AH" name="cbThoContent" className='add-only' value="AH" />
                AH
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbThoContent_VH" name="cbThoContent" className='add-only' value="VH" />
                VH
            </td> 
        </tr>
        <tr> 
            <td className='w-500'>
                <input type="checkbox" id="cbThoContent_Other" name="cbThoContent" className='add-only' value="Other" />
                Other:
                    <input type='text' id="txtThoContent_Other" name="txtThoContent_Other" className='add-only' />
            </td>
        </tr>
    </table>
    <table>
        <tr>
            <td className='w-375'>
                <span className='eleHeader'>Insight/Judgment</span>
                <select id="ddlInsight" name="ddlInsight" className='add-only'>
                    <option value="NA"></option>
                    <option value="Good">Good</option>
                    <option value="Fair">Fair</option>
                    <option value="Poor">Poor</option>
                </select>
            </td>
            <td className='w-375'>
                <span className='eleHeader'>Reliability of Information</span>
                <select id="ddlReliabOfInformation" name="ddlReliabOfInformation" className='add-only'>
                    <option value="NA"></option>
                    <option value="Very Good">Very Good</option>
                    <option value="Good">Good</option>
                    <option value="Fair">Fair</option>
                    <option value="Poor">Poor</option>
                </select>
            </td>
        </tr>
    </table>
    <p>
        <span className='eleHeader'>Other</span>
        <textarea id="txtOther" name="txtOther" className='add-only' rows={5}></textarea>
    </p>
    <h4>Diagnosis</h4>
    <p>
        <textarea id="txtDiagnosis" name="txtDiagnosis" className='add-only' rows={5}></textarea>
    </p>
    <table>
        <tr>
            <td className='w-750'>
                <span className='eleHeader'>Prognosis</span>
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbPrognosis_Poor" name="cbPrognosis" className='add-only' value="Poor" />
                Poor
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbPrognosis_Fair" name="cbPrognosis" className='add-only' value="Fair" />
                Fair
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbPrognosis_Good" name="cbPrognosis" className='add-only' value="Good" />
                Good
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbPrognosis_Excellent" name="cbPrognosis" className='add-only' value="Excellent" />
                Excellent
            </td>
            <td className='w-250'>&nbsp;</td>
            <td className='w-250'>&nbsp;</td>
        </tr>
    </table>
    <h4>Recommendation</h4>
    <table>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbRecommendation_1" name="cbRecommendation" className='add-only' value="Continue Services from ACE" />
                Continue Services from ACE
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbRecommendation_2" name="cbRecommendation" className='add-only' value="Consent Obtained" />
                Consent Obtained
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbRecommendation_3" name="cbRecommendation" className='add-only' value="Explained risks/benefits of Medication" />
                Explained Risks/Benefits of Medication
            </td>
        </tr>
        <tr>
            <td className='w-750'>
                <span className='eleHeader'>Labs</span>
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbLabs_ComprehensiveMetabolicPanel" name="cbLabs" className='add-only' value="Comprehensive Metabolic Panel" />
                Comprehensive Metabolic Panel
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbLabs_ThyroidStudies" name="cbLabs" className='add-only' value="Thyroid Studies" />
                Thyroid Studies
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbLabs_CBC" name="cbLabs" className='add-only' value="CBC w/diff" />
                CBC w/diff
            </td>
        </tr>
        <tr>
            <td className='w-250'>
                <input type="checkbox" id="cbLabs_PtEducation" name="cbLabs" className='add-only' value="Pt education materials given" />
                Pt education materials given
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbLabs_ADHDCheckList" name="cbLabs" className='add-only' value="ADHD check list" />
                ADHD check list
            </td>
            <td className='w-250'>
                <input type="checkbox" id="cbLabs_FeedbackFromSchool" name="cbLabs" className='add-only' value=" Feedback from school" />
                Feedback from school
            </td>
        </tr>
        <tr>
            <td className='w-750'>
                <input type="checkbox" id="cbLabs_Other" name="cbLabs" className='add-only' value="Other" />
                Other:
                    <input type='text' id="txtLabs_Other" name="txtLabs_Other" className='add-only' />
            </td>
        </tr>
    </table>
    <p>
        <span className='eleHeader'>Recommend</span>
        <textarea id="txtRecommend" name="txtRecommend" className='add-only' rows={5}></textarea>
    </p>
    <p>
        <span className='eleHeader'>RTC</span>
        <select id="ddlRTC" name="ddlRTC" className='add-only'>
            <option value="N/A"></option>
            <option value="1 Week">1 Week</option>
            <option value="2 Weeks">2 Weeks</option>
            <option value="3 Weeks">3 Weeks</option>
            <option value="4 Weeks">4 Weeks</option>
            <option value="5 Weeks">5 Weeks</option>
            <option value="6 Weeks">6 Weeks</option>
            <option value="7 Weeks">7 Weeks</option>
            <option value="8 Weeks">8 Weeks</option>
            <option value="12 Weeks">12 Weeks</option>
        </select>
    </p>
    <p>
        <span className='eleHeader'>STATEMENT</span>
        <input type="checkbox" id="cbStatement" name="cbStatement" className='add-only' value="statement" />
        I am supervising physician to Nurse Practitioner and have discussed patient's case and agree with above-written note.
    </p>

    <table>
        <tr>
            <td className="signature w-600">&nbsp;</td>
            <td className="signature w-150">&nbsp;</td>
        </tr>
        <tr>
            <td className="small w-600">Physician Signature/Title</td>
            <td className="small w-150">Date</td>
        </tr>
        <tr>
            <td className="signature w-600">&nbsp;</td>
            <td className="signature w-150">&nbsp;</td>
        </tr>
        <tr>
            <td className="small w-600">Please Type/Print Name and Title</td>
            <td className="small w-150">&nbsp;</td>
        </tr>
        <tr>
            <td className="signature w-600">&nbsp;</td>
            <td className="signature w-150">&nbsp;</td>
        </tr>
        <tr>
            <td className="small w-600">Co-signer Signature/Title</td>
            <td className="small w-150">Date</td>
        </tr>
        <tr>
            <td className="signature w-600">&nbsp;</td>
            <td className="signature w-150">&nbsp;</td>
        </tr>
        <tr>
            <td className="small w-600">Please Type/Print Name and Title</td>
            <td className="small w-150">&nbsp;</td>
        </tr>


    </table> 

 

                



            </div>
        </form>

    )
}    